import React from "react"

import { Media } from "@/services/Media"
import { ChannelType } from "@/protocols/channel"

import { beautifyBytes } from "@/utils/format"
import { getMediaSizeLimitInBytes, formatMediaSizeLimit } from "@/config/mediaLimits"

import { ActionDialog } from "@/components"

class MediaValidation {
	async validateMedia (media: Media, channelType: ChannelType | undefined, onSuccess: () => Promise<void> | void): Promise<void> {
		const isVideoMedia = media.type === "video"
		const hasValidVideoSize = this.hasValidVideoSize(media.data.size, channelType)

		if (isVideoMedia && !hasValidVideoSize) {
			ActionDialog.open({
				title: "Vídeo muito grande",
				hideCloseButton: true,
				openDialog: true,
				children: (
					<>
						O vídeo que você está tentando usar pesa <b>{beautifyBytes(media.data.size, 0)}</b>,
						{" "}
						porém só é possível enviar vídeos menores que <b>{formatMediaSizeLimit("video", channelType)}</b>.
					</>
				)
			})
		} else {
			await onSuccess()
		}
	}

	private hasValidVideoSize (sizeInBytes: number, channelType: ChannelType | undefined): boolean {
		const videoSizeLimitInBytes = getMediaSizeLimitInBytes("video", channelType)
		const hasValidSize = sizeInBytes <= videoSizeLimitInBytes

		return hasValidSize
	}
}

export default new MediaValidation()
